import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/_services/app.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  userInfo: any;

  constructor(
    private appService: AppService

  ) { }

  ngOnInit(): void {
    this.appService.postService({}, 'login/GetUserInfo').subscribe(response => {
      this.userInfo = response.body.result
      console.log(this.userInfo);
      this.appService.userInfo.next(this.userInfo)
    })
  }

}
